import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from "rxjs";
import { isValidCNES, isValidCNPJ, isValidCNS, isValidCPF } from "../util/validation";
import { ToastrService } from "ngx-toastr";
import { AuthService } from './auth.service';
import {URL_PORTAL_SERVICOS_API} from "../util/constants";

@Injectable()
export class ConsultaService {

  constructor(
    public http: HttpClient,
    private toast: ToastrService,
    private authService: AuthService
  ) {
  }

  consultarEstabelecimentoPorCNPJ(cnpj): Promise<any> {
    cnpj = cnpj.toString().replace(/\D/g, '');

    if (!isValidCNPJ(cnpj)) {
      this.toast.error('CNPJ inválido');
      return;
    }

    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/servicos/consultarEstabelecimentoPorCNPJ?numCNPJ=${ cnpj }`).toPromise();
  }

  consultarEstabelecimentoPorCNES(cnes): Promise<any> {
    if (!isValidCNES(cnes)) {
      this.toast.error('CNES inválido');
      return;
    }

    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/servicos/consultarEstabelecimentoPorCNES?codigoCNES=${ cnes.toString().replace(/\D/g, '') }`).toPromise();
  }

  consultarEstabelecimentoEsusPorCNES(cnes): Promise<any> {
    if (!isValidCNES(cnes)) {
      this.toast.error('CNES inválido');
      return;
    }

    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/estabelecimento-esus/buscarPorCnes?coCnes=${ cnes.toString().replace(/\D/g, '') }`).toPromise();
  }


  consultarEstabelecimentoPorCredenciais(cnes): Promise<any> {
    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/servicos/consultaCredenciaisPorCNES?codigoCNES=${ cnes.toString().replace(/\D/g, '') }`).toPromise();
  }

  consultarEstabelecimentoEsusFilhoPorCNES(params): Promise<any> {

    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/estabelecimento-esus/buscarEstabelecimentosFilhos?coMunicipioIbge=${ params.coMunicipioIbge }&sgUf=${ params.sgUf }`).toPromise();
  }

  consultarEstabelecimentoFilhoPorCSV(params): Promise<any> {
    let file = params.base64CsvFile.split(';base64,');

    return this.http.post(`${ URL_PORTAL_SERVICOS_API }/servicos/consultarEstabelecimentoPorCNES/validarArquivoCNES?cnesPai=`+params.cnesPai, {
      base64CsvFile: file[1]
    }).toPromise();
    /*
    const tokenScab = this.authService.getLocalTokenBarramento();
    const tokenBc = this.authService.getLocalTokenBrasilCidadao();

    let formData = new FormData(params.body);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', URL_PORTAL_SERVICOS_API + '/servicos/consultarEstabelecimentoPorCNES/validarArquivoCNES');
          xhr.onload = (event: any) => {
            resolve(JSON.parse(event.target.response));
          };
          xhr.onerror = (event: any) => {
              reject(JSON.parse(event.target.response));
          };
          formData.append('cnesPai', params.cnesPai);
          formData.append('base64CsvFile', params.base64CsvFile);

          xhr.setRequestHeader('Authorization', tokenScab);
          xhr.setRequestHeader('AuthorizationSerpro', tokenBc);
          xhr.send(formData);
      });
      */
  }


  consultarUsuarioSusPorCNS(cns): Promise<any> {
    if (!isValidCNS(cns)) {
      this.toast.error('CNS inválido');
      return;
    }

    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/servicos/consultarUsuarioSusPorCNS?cns=${ cns.toString().replace(/\D/g, '') }`).toPromise();
  }

  consultarUsuarioSusPorCPF(cpf): Promise<any> {
    cpf = cpf.toString().replace(/\D/g, '');

    if (!isValidCPF(cpf)) {
      this.toast.error('CPF inválido');
      return;
    }

    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/servicos/consultarUsuarioSusPorCPF?cpf=${ cpf }`).toPromise();
  }


  validarUsuarioSUSPertenceCnes(cpf?, cnes?, cns?) {
    let params = '?cnes='+ cnes;
    if (cpf) {
      cpf = cpf.toString().replace(/\D/g, '');

      if (!isValidCPF(cpf)) {
        this.toast.error('CPF inválido');
        return;
      }

      params += '&cpf='+cpf;
    }

    if (cns) {
      if (!isValidCNS(cns)) {
        this.toast.error('CNS inválido');
        return;
      }
      params += '&cns='+cns;
    }

    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/servicos/validarUsuarioSusPertenceCNES`+params).toPromise();

  }

  listarServicosDisponiveis(): Observable<any> {
    return this.http.get(`${ URL_PORTAL_SERVICOS_API }/servicos/listarServicosDisponiveis`);
  }

  buscarPortfolioPorId(id: number): Promise<any> {
    return this.http.post(`${ URL_PORTAL_SERVICOS_API }/portfolio/buscarPortfolioPorId?codigoPortfolio=${ id }`, {}).toPromise();
  }

  alterarDadosServico(solicitacao): Promise<any> {
    return this.http.post(`${ URL_PORTAL_SERVICOS_API }/solicitacao/atualizarSolicitacaoExterna`, solicitacao).toPromise();
  }

  enviarSolicitacao(params): Promise<any> {
    try {
      return this.http.post(`${ URL_PORTAL_SERVICOS_API }/solicitacao/titularidade`, params).toPromise().catch(error => {
        this.toast.error(error.error.message);
      });
    } catch (e) {
      console.log(e);
    }
  }

  estabelecimentosFilhosLote(body): Promise<any> {
    try {
      return this.http.post(`${ URL_PORTAL_SERVICOS_API }/estabelecimento-filho/emLote`, body).toPromise().catch(error => {
        this.toast.error(error.error.message);
      });
    } catch (e) {
      console.log(e);
    }
  }


  extrairCertificado(dsCert: string): Promise<any> {
    return this.http.post(`${ URL_PORTAL_SERVICOS_API }/credencialUsuario/extrairCertificado`, { dsCertificado: dsCert}).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/consulta.service.ts